export default __webpack_public_path__ + "media/images/icons/shield-check-fc85a09277757c2eb256ddb83763820e.svg";